import React, { PureComponent } from 'react';
import Collapse from '@material-ui/core/Collapse';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../constants/text';
import { colors } from '../../../constants/colors';
import StarSelector from '../../SolvPatternLibrary/StarSelector';

export const PRIMARY_RATING = 'primary rating';

const FLAVOR_COPY = {
  1: 'Worst ever',
  2: 'Not good',
  3: 'Just ok',
  4: 'I liked it',
  5: 'It was great!',
};

const Root = styled.div`
  text-align: center;
  padding: 26px 20px;
`;

const Title = styled.h1`
  margin: 0 auto 20px;
  display: block;
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.large};
  color: ${colors.blueMonday};
`;

const FlavorText = styled(Collapse)`
  margin: 20px auto 0;
  font-family: ${fontFamily.book};
  font-size: ${fontSize.medium};
  color: ${colors.peaches};
`;

type Props = {
  leaveAReview?: any;
  onChange?: (...args: any[]) => any;
};

export default class PrimaryRatingSelector extends PureComponent<Props> {
  onChangeInterpreter = (value: any) => {
    const { onChange } = this.props;

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    onChange({ value, genre: PRIMARY_RATING });
  };

  render() {
    const { leaveAReview } = this.props;
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const flavorCopy = FLAVOR_COPY[leaveAReview[PRIMARY_RATING]];
    return (
      <Root data-testid="primary-rating-selector-root">
        <Title>How was your overall experience?</Title>

        <StarSelector
          onChange={this.onChangeInterpreter}
          rating={leaveAReview[PRIMARY_RATING]}
          starWidth={43}
        />

        <FlavorText in={!!flavorCopy} timeout="auto">
          {flavorCopy}
        </FlavorText>
      </Root>
    );
  }
}
